export default __webpack_public_path__ + "static/media/User.b08c9821.svg";